var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 12.5V15H4.99967V12.5H3.33301V15C3.33301 15.9167 4.08301 16.6667 4.99967 16.6667H14.9997C15.9163 16.6667 16.6663 15.9167 16.6663 15V12.5H14.9997ZM14.1663 9.16668L12.9913 7.99168L10.833 10.1417V3.33334H9.16634V10.1417L7.00801 7.99168L5.83301 9.16668L9.99967 13.3333L14.1663 9.16668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/Download_white.f94bade4f48583cda00fbc8cc458f64c.svg";
export { ForwardRef as ReactComponent };